<!--
入力内容表示コンポーネント
単位あり
-->
<template>
  <div class="value-container">
    <div class="value-font" :data-test="dataTest">{{ value | checkNull }}</div>
    <div class="unit-font">{{ unit }}</div>
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    value: {
      required: true
    },
    unit: VueTypes.string.isRequired,
    dataTest: VueTypes.string
  },
  filters: {
    checkNull(value) {
      if (value === null || value === "" || value === undefined) {
        return "--";
      } else {
        return value;
      }
    }
  }
};
</script>

<style scoped>
.value-container {
  display: flex;
  justify-content: flex-end;
}
.value-font {
  font-weight: bold;
  font-size: 16px;
  margin-right: 3px;
}
</style>
